import React from "react";
import "./OtherPages.scss";
import { Link } from "react-router-dom";
function PrivacyPolicy() {
	return (
		<div className="terms_condition spacing">
			<div className="container">
				<h1>Privacy Policy</h1>

				<div className="terms_condition_content spacing">
					<p>
						Please read the following Privacy policy of the services made available on https://shubhraranjan.com or the equivalent Shubhra Ranjan Mobile Application available on Google Play, Windows Store or Apple Store <b> ("Shubhra Ranjan App"/ "Website")</b>. The Shubhra Ranjan App or Website on
						which the Services are availed may together be referred to for convenience as the <b> "Platform" </b>.
					</p>
					<p>
						For the purpose of these privacy policies, wherever the context so requires <b> "Your", "You" or "User" </b> shall mean any natural or legal person who browses the Platform or has agreed to become a subscriber to the Services on the Platform by providing login credentials while
						registering on our website as a Subscribed User using the computer systems. The term <b> "We", "Us", "Our" </b> shall mean Shubhra Ranjan IAS Study Pvt. Ltd. ("<b>Shubhra Ranjan</b>").
					</p>
					<p>Please ensure that this Privacy Policy is perused by You before availing any services from Us. This Privacy Policy shall be updated from time to time and to stay abreast with our methods of using Your information and protecting Your privacy, please keep reviewing this Policy.</p>
					<p>By viewing the Shubhra Ranjan Platform, you agree to be bound by the terms of this Privacy Policy.</p>
					<p>
						By using the Shubhra Ranjan Platform and/or by providing Your information, You consent to the collection and use of the information You disclose on our Website in accordance with this Privacy Policy, including but not limited to your consent for sharing your information as per this
						Privacy Policy. If we decide to change our Privacy Policy, We will post those changes on this page so that You are always aware of what information We collect, how We use it, and under what circumstances We disclose it. If You do not agree for the forgoing, please do not continue to use
						or access our Website.
					</p>

					<h5>1. Collection of Personally Identifiable Information</h5>
					<ol>
						<li>
							We collect certain information about You to help us serve You better. The information collected by Us is of the following nature:
							<ol className="alphaBate">
								<li>Name</li>
								<li>Telephone Number</li>
								<li>Email Address</li>
								<li>Permanent and Current Address</li>
								<li>Other information about the service address which You give Us</li>
								<li>Your IP address</li>
								<li>Information about your device</li>
								<li>Network information</li>
								<li>College/ Institution Details and location</li>
								<li>User uploaded photo and ids</li>
								<li>Demographic information such as postcode, preferences and interests</li>
								<li>Any other personal information which you give us in connection while booking a service or is relevant to customer surveys and/or offers. In case you have submitted your personal information and contact details, we reserve the rights to Call, SMS, Email or WhatsApp about our products and offers, even if your number has DND activated on it.</li>
							</ol>
						</li>
						<li>
							Information provided during Registration to create a profile and use this Website and services, you may be asked to provide the following information: your name, email address, address, education, address proof. You may also choose to provide a picture to be associated with your
							profile.
						</li>
						<li>We provide an option to register using only Google Id. Please note that if you register to the Platform through Google Id, You shall be subject to the Terms & Conditions and Privacy Policy of Google.</li>
						<li> We will store your name, address, Address Proof and contact number. These information elements are referred to collectively as your “Personal User Information.” We collect and hold this information for the purpose of administering your use of the Application.</li>
						<li>
							You are solely responsible for:
							<ol className="alphaBate">
								<li>Maintaining the strict confidentiality of your Personal User Information</li>
								<li>Not allowing another person to use your Personal User Information to access the Services</li>
								<li>Any and all damages or losses that may be incurred or suffered as a result of any activities that occur in your Account</li>
								<li>Ensuring that the information submitted by you complies with our terms and conditions</li>
								<li>Ensuring that the information provided by you is correct and updated from time to time</li>
							</ol>
						</li>

						<li>
							You agree to immediately notify Shubhra Ranjan in writing by email to admin@shubhraranjan.com of any unauthorized use of your Personal User Information or any other breach of security. Shubhra Ranjan is not and shall not be liable for any harm arising from or relating to the theft of
							your Personal User Information that is under Your control, your disclosure of your Personal User Information, or the use of your Personal User Information by another person or entity.
						</li>
						<li>
							On receiving personal information about You, You no longer remain anonymous to Us. We may use this information to do internal research on demographics, interests, and behaviour to better understand, protect and serve our customers. This information is compiled and analysed on an
							aggregated basis. We indicate fields that are mandatorily required to be filled and fields that are optional. You may decide whether or not to provide such information to Us.
						</li>
						<li>
							You may choose not to provide us with any personal information or information as required to provide any Services. If we do not receive information required, we may choose not to provide you with such Service. Service shall have the meaning attributed to the phrase in the Terms of Use.
						</li>
						<li>
							On our Website, you can browse without telling Us who you are or revealing any personal information about Yourself. We may automatically track certain information about You based on Your behaviour on our Website. This information may include the URL that You just came from (whether
							this URL is on our Website or not), which URL You next go to (whether this URL is on our Website or not), Your browser information, and Your IP address.
						</li>
						<li>
							On our Websites, We use data collection devices such as "cookies" on certain pages to help analyse our web page flow, measure promotional effectiveness, and promote trust and safety. "Cookies" are small files placed on your hard drive that assist Us in providing our services. We offer
							certain features that are only available through the use of a "cookie". You are always free to decline our cookies if Your browser permits, although in that case You may not be able to use certain features on the Websites. Additionally, You may encounter "Cookies" or other similar
							devices on certain pages of the Website that are placed by third parties. We do not control the use of cookies by third parties.
						</li>
					</ol>

					<h5>2. Use of Personal Information</h5>
					<ol>
						<li>
							2.1 The information collected by Us through our Website is used by Us for various purposes to enable us to serve you better:
							<ol className="alphaBate">
								<li>To find third party service providers</li>
								<li>Internal record keeping</li>
								<li>We may use the information to improve our products and services</li>
								<li>We may periodically send promotional emails or messages on the Website about new products, special offers or other information which We think You may find interesting using the email address which You have provided</li>
								<li>From time to time, we may use the information to customize the Website according to your interests</li>
							</ol>
						</li>
						<li>
							We may use personal information to resolve disputes that may arise with the use of our Services, help promote a safe service to all the customers, measure consumer interest in our services, customize your experience, detect and protect Us against error, fraud and other criminal
							activity, enforce our terms and conditions.
						</li>
						<li>We identify and use your IP address to help diagnose problems with our server, and to administer our Websites. Your IP address is also used to help identify You and to gather broad demographic information.</li>
					</ol>

					<h5>3. Sharing of Personal Information</h5>
					<ol>
						<li>We may share your information with payment service providers, regulatory authorities, and third-party agencies in the event of any request from such authorities.</li>
						<li>
							We may disclose Your personal information if required to do so by law or in the good faith and belief that such disclosure is reasonably necessary to respond to subpoenas, court orders, or other legal process. We may disclose personal information to law enforcement offices, third party
							rights owners, or others in the good faith belief that such disclosure is reasonably necessary to enforce our Terms or Privacy Policy; respond to claims that an advertisement, posting or other content violates the rights of a third party; or protect the rights, property or personal
							safety of our customers or the general public.
						</li>
						<li>
							We and our affiliates will share/sell some or all of the collected information with another business entity should We (or our assets) plan to merge with, or be acquired by that business entity, or re-organization, amalgamation, restructuring of business. Should such a transaction
							occur, that other business entity (or the new combined entity) will be required to follow this Privacy Policy with respect to all the information collected.
						</li>
						<li>
							We do not disclose personal information about identifiable individuals to advertisers, but We may provide them with aggregate and/or anonymised information about You to help advertisers reach the kind of audience they want to target. We may make use of the information We have collected
							from You to enable Us to comply with our advertisers' wishes by displaying their advertisement to that target audience.
						</li>
						<li>If you choose to subscribe to any Shubhra Ranjan course you may be required to upload a copy of a valid government issued identification document to allow access to the Platform.</li>
					</ol>

					<h5>4. Information Safety</h5>
					<ol>
						<li>All information is saved and stored on servers which are secured with passwords and pins to ensure no unauthorised person has access to it. Once your information is in our possession we adhere to strict security guidelines, protecting it against unauthorized access.</li>
					</ol>

					<h5>5. Choice/Opt-Out</h5>
					<ol>
						<li>
							We provide all customers with the opportunity to opt-out of receiving non-essential (promotional, marketing-related) communications from Us on behalf of our partners, and from Us in general, after providing Us with personal information. If You want to remove your contact information
							from all lists and newsletters, please write to <a href="maito:admin@shubhraranjan.com">admin@shubhraranjan.com</a> .
						</li>
					</ol>

					<h5>6. Third Party Links</h5>
					<ol>
						<li>
							We use third-party advertising companies to serve advertisements when You visit our Website. These companies may use information (not including your name, address, email address, or telephone number) about your visits to this and other Website in order to provide advertisements about
							services of interest to You.
						</li>
					</ol>

					<p>
						<b>All other terms and conditions as applicable under the Terms and Conditions of Use <Link to="https://shubhraranjan.com">https://shubhraranjan.com</Link> will be applicable to You and will be read along with this Privacy Policy.</b>
					</p>

					<h5>7. Delete Account</h5>
					<ol>
						<li>
							User can delete account permanently either by selecting menu in the profile section of Android app and IOS app or from outside the App, user can click on the below link and follow the instructions on the web page to delete an account. After deleting an account, User’s data will be permanently deleted.
						</li>
					</ol>

					<p>
						<b><Link to="/delete-account">https://staging.shubhraranjan.com/delete-account</Link></b>
					</p><br />
					<h6 style={{ color: "red", fontSize: "18px" }}>
						<u>Disclaimer</u> : <br />
						<span>
							Shubhra Ranjan is NOT GOVERNMENT ORGANISATION and not linked with the Government of India and any State Government in any way. <br />
							The application DO NOT represent or endorse or linked, authorised or sponsored by any Indian government entity or any of its subsidiaries or its affiliates in any way. <br />
							The content within our application, though inspired by the UPSC syllabus, is entirely original and developed solely for educational purposes. It does not contain nor reproduce any official government document.
						</span>
					</h6>
				</div>
			</div>
		</div>
	);
}

export default PrivacyPolicy;
